import React, { useMemo } from "react";
import { Fade, Box, Typography } from "@mui/material";
import PlayStoreImage from "../../assets/img/googlePlay.svg";
import AppStoreImage from "../../assets/img/appStore.svg";
import WarningImage from "../../assets/img/warningImage.svg";
import ErrorImage from "../../assets/img/errorImage.svg";
import CloseIcon from "@mui/icons-material/Close";
import classes from "./index.module.css";
import {
    USER_EXIST_IN_KARDIA_APP_CODE,
    USER_EXIST_CODE_GENERAL_2,
    USER_NOT_EXIST_CODE,
} from "constants/app";
import { appsStoreNavigation } from "utilities";

const contentMap = {
    [USER_EXIST_CODE_GENERAL_2]: (
        <>
            <Typography>
                Follow the link below for your respective device to download the
                KardiaComplete App.
            </Typography>
            <Typography>
                Then log in to begin enjoying your KardiaComplete experience.
            </Typography>
        </>
    ),
    [USER_NOT_EXIST_CODE]: (
        <>
            <Typography>
                Please confirm all information, including first name, last name, and
                date of birth, have been correctly filled in.
            </Typography>
            <Typography>
                For additional support, contact kardiacomplete@alivecor.com or call
            </Typography>
            <Typography>+1 (855) 578-1085.</Typography>
        </>
    ),
    [USER_EXIST_IN_KARDIA_APP_CODE]: (
        <Typography>
            This email is already connected to a Kardia account and cannot be used
            for a KardiaComplete account. Please use a different email address to
            complete your KardiaComplete registration.
        </Typography>
    ),
};

const EnrollmentErrorModal = ({ open, code, message, handleClose }) => {
    const isError = code === USER_EXIST_IN_KARDIA_APP_CODE;

    return (
        <Fade in={open}>
            <Box className={classes.modalBox}>
                <Box className={classes.crossStyle}>
                    <CloseIcon className={classes.modalCloseIcon} onClick={handleClose} />
                </Box>
                <Box className={classes.modalStyle}>
                    <img
                        className={classes.modalHeaderImage}
                        src={isError ? ErrorImage : WarningImage}
                        alt={isError ? "Error" : "Warning"}
                    />
                    <Typography variant="h5" className={classes.modalTitle}>
                        {message}
                    </Typography>
                    <Typography className={classes.modalBody}>
                        {contentMap[code] || contentMap[USER_EXIST_CODE_GENERAL_2]}
                    </Typography>
                    {!isError && (
                        <Box className={classes.modalFooter}>
                            <img src={PlayStoreImage} alt="Google Play Store" onClick={appsStoreNavigation} role="link" />
                            <img src={AppStoreImage} alt="Apple App Store" onClick={appsStoreNavigation} role="link" />
                        </Box>
                    )}
                </Box>
            </Box>
        </Fade>
    );
};

export default EnrollmentErrorModal;
